import Immutable from 'immutable';
import * as types from './Search.types';

const initialState = {
    items: [],
    fetching: false,
    search: '',
    searchType: 'name',
    productType: 5,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.SEARCH_ITEMS:
            return state.setIn(['fetching'], true).toJS();

        case types.SEARCH_ITEMS_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['items'], action.payload)
                .toJS();

        case types.SEARCH_ITEMS_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.SET_SEARCH:
            return state.setIn(['search'], action.payload).toJS();

        case types.SET_SEARCH_TYPE:
            return state.setIn(['searchType'], action.payload).toJS();

        case types.SET_PRODUCT_TYPE:
            return state.setIn(['productType'], action.payload).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}